import { useNavigate } from "react-router-dom";
import CustomButton from "../shared/custom-button/custom-button";
import "./IndustryOverView.scss";
import { NavLink } from "react-router-dom";

const IndustryOverView = ({ overviewData }) => {
  const navigate = useNavigate();
  return (
    <section className="industry-overview-section">
      <div className="overview-container">
        {overviewData?.icon && (
          <img
            src={overviewData.icon}
            alt="watermark"
            className="watermark-icon"
          />
        )}
        <div className="content-wrapper">
          <h6>Industry Overview</h6>
          <p>{overviewData?.description || "Description not available."}</p>
          <div className="cta-button">
            <CustomButton
              to={"/contact"}
              as={NavLink}
              variant="primary"
              onClick={() => navigate("/contact")}
            >
              Request a Consultation
            </CustomButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryOverView;
